import { Damage, DamageStatus } from '../models'

/** Matches `DamageRequestFilters` from the damage list — kept here to avoid helpers↔hooks cycles */
export type DamageTotalCostFilters = {
    excludeDenied?: boolean
    statuses?: string
}

export function damageLineCost(damage: Damage): number {
    return damage.amount * damage.cost
}

/** Whether a damage in `status` contributes to `get_total_cost` for these request filters */
export function damageIncludedInTotalCostForRequestFilters(
    status: DamageStatus,
    filters: DamageTotalCostFilters,
): boolean {
    const excludeDenied = filters.excludeDenied !== false
    if (excludeDenied && status === DamageStatus.DENIED) {
        return false
    }
    const raw = filters.statuses?.trim()
    if (!raw) {
        return true
    }
    const statuses = raw.split(',').map((s) => s.trim()) as DamageStatus[]
    return statuses.includes(status)
}

/** Delta to apply to a total-cost figure when damages move to `newStatus` under `filters` */
export function damageCostDeltaForStatusChange(
    damages: Damage[],
    newStatus: DamageStatus,
    filters: DamageTotalCostFilters,
): number {
    let delta = 0
    for (const d of damages) {
        const line = damageLineCost(d)
        const before = damageIncludedInTotalCostForRequestFilters(
            d.status,
            filters,
        )
        const after = damageIncludedInTotalCostForRequestFilters(
            newStatus,
            filters,
        )
        delta += (after ? line : 0) - (before ? line : 0)
    }
    return delta
}
